export default __webpack_public_path__ + "static/media/blog2.17508aed.jpg";